export default [
    {
        path: '/campaign',
        props: true,
        component: () => import('@/views/Campaign'),
    },
    {
        path: '/campaign/:id/builder',
        props: true,
        component: () => import('@/views/Campaign/Builder'),
    },
];
